import { TUser } from '@cockpitai/integration/auth/types'
import { StateCreator } from 'zustand'

export interface IUserSlice {
  user: TUser | null
  setUser(user: TUser | null): void
}

export const createUserSlice: StateCreator<IUserSlice, [], [], IUserSlice> = (
  set,
) => ({
  user: null,
  setUser: (user: TUser | null) => set(() => ({ user })),
})
